import { render, staticRenderFns } from "./add-collection.vue?vue&type=template&id=e7e07e32&scoped=true&"
import script from "./add-collection.vue?vue&type=script&lang=js&"
export * from "./add-collection.vue?vue&type=script&lang=js&"
import style0 from "./add-collection.vue?vue&type=style&index=0&id=e7e07e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e07e32",
  null
  
)

export default component.exports